import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../api/api";

export const OrderDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.orders.getOne(id).then(res => {
      const data = res?.order || res;
      setOrder(data);
    });
  }, [id]);

  if (!order) {
    return (
      <div className="p-4 animate-pulse">
        <div className="h-6 w-40 bg-gray-200 rounded mb-4"></div>
        <div className="h-20 bg-gray-200 rounded-xl mb-3"></div>
        <div className="h-20 bg-gray-200 rounded-xl"></div>
      </div>
    );
  }

  const status = order.status;

  const getImage = (item) =>
    item?.productId?.images?.[0] ||
    item?.image ||
    "/placeholder.png";

  return (
    <div className="min-h-screen bg-[#f9f9f9] pb-10">

      {/* HEADER */}
      <div className="bg-white p-4 shadow-sm flex items-center gap-3">
        <button onClick={() => navigate(-1)}>
          ←
        </button>

        <div>
          <p className="font-bold text-[16px]">
            {order.storeName}
          </p>
          <p className="text-[12px] text-gray-500">
            {order.orderId}
          </p>
        </div>
      </div>

      <div className="p-4 space-y-4">

        {/* TOP STATUS ACTION */}
<div className="bg-white p-4 shadow-sm sticky top-0 z-10">
  <p className="text-[13px] text-gray-500 mb-2">Update Order Status</p>

  <div className="flex gap-2 overflow-x-auto pb-1">

    {[
      { key: "processing", label: "Accept" },
      { key: "shipped", label: "Ready" },
      { key: "delivered", label: "Completed" }
    ].map((step) => {
      const isActive = order.status === step.key;

      return (
        <button
          key={step.key}
          onClick={async () => {
            if (order.status === step.key) return;

            try {
              setOrder(prev => ({ ...prev, status: step.key }));
              await api.orders.updateStatus(order._id, { to: step.key });
            } catch (err) {
              console.error(err);
            }
          }}
          className={`px-4 py-2 rounded-full text-[13px] font-medium whitespace-nowrap transition
            ${
              isActive
                ? "bg-green-500 text-white"
                : "bg-gray-100 text-gray-600"
            }
          `}
        >
          {step.label}
        </button>
      );
    })}

  </div>

  {/* CURRENT STATUS */}
  <div className="mt-3 flex items-center justify-between">
    <span className="text-[12px] text-gray-500">Current Status</span>
    <span className="text-[12px] font-semibold capitalize text-green-600">
      {order.status}
    </span>
  </div>
</div>

        {/* ITEMS */}
        <div className="bg-white p-4 rounded-xl shadow-sm">
  <p className="font-semibold mb-3">Items</p>

  {order.items.map((item, i) => {
    const price = item.basePrice || 0;

    return (
      <div key={i} className="flex gap-3 mb-4">
        
        {/* Image */}
        <img
          src={getImage(item)}
          className="w-16 h-16 rounded-lg object-cover bg-gray-100"
        />

        {/* Info */}
        <div className="flex-1">
          <p className="font-medium text-[14px]">
            {item.name}
          </p>

          <p className="text-[12px] text-gray-500">
            {item.quantity} × ₦{price.toLocaleString()}
          </p>

          <p className="text-[13px] font-semibold mt-1">
            ₦{(price * item.quantity).toLocaleString()}
          </p>
        </div>

      </div>
    );
  })}
</div>

        {/* DELIVERY */}
        <div className="bg-white p-4 rounded-xl shadow-sm">
  <p className="font-semibold mb-2">Delivery Info</p>

  <p className="text-[13px]">
    <span className="font-medium">Type:</span>{" "}
    {order.deliveryType === "pickup" ? "Pickup" : "Delivery"}
  </p>

  {order.deliveryType === "delivery" && order.shippingAddress ? (
    <p className="text-[13px] text-gray-600 mt-1">
      {order.shippingAddress.street}, {order.shippingAddress.city}
    </p>
  ) : (
    <p className="text-[12px] text-gray-400 mt-1">
      Customer will pick up this order
    </p>
  )}
</div>

        {/* CONTACT */}
        <div className="bg-white p-4 rounded-xl shadow-sm">
          <p className="font-semibold mb-2">Contacts</p>

          <p className="text-[13px]">
            Buyer: {order.buyerPhone}
          </p>

          <p className="text-[13px]">
            Rider: {order.riderPhone || "Not assigned"}
          </p>
        </div>

        {/* PAYMENT SUMMARY */}
        <div className="bg-white p-4 rounded-xl shadow-sm">
  <p className="font-semibold mb-3">Earnings</p>

  {/* Items Breakdown */}
  {order.items.map((item, i) => {
    const base = item.basePrice || 0;
    const qty = item.quantity || 0;
    const total = base * qty;

    return (
      <div key={i} className="flex justify-between text-[13px] mb-1">
        <span>
          {item.name} × {qty}
        </span>
        <span>₦{total.toLocaleString()}</span>
      </div>
    );
  })}

  {/* Divider */}
  <div className="border-t my-2"></div>

  {/* Vendor Total */}
  <div className="flex justify-between font-bold text-[15px]">
    <span>Total Earnings</span>
    <span>
      ₦
      {order.items
        .reduce((sum, item) => {
          const base = item.basePrice || 0;
          const qty = item.quantity || 0;
          return sum + base * qty;
        }, 0)
        .toLocaleString()}
    </span>
  </div>
</div>

        {/* ACTION */}
        {/* <div className="bg-white p-4 rounded-xl shadow-sm">
          <p className="font-semibold mb-2">Update Status</p>

          <select
            className="w-full border p-3 rounded-lg bg-gray-50"
            onChange={async (e) => {
              const newStatus = e.target.value;
              if (!newStatus) return;

              try {
                setOrder(prev => ({ ...prev, status: newStatus }));
                await api.orders.updateStatus(order._id, { to: newStatus });
              } catch (err) {
                console.error(err);
              }
            }}
          >
            <option value="">Select status</option>
            <option value="processing">Processing</option>
            <option value="shipped">Shipped</option>
            <option value="delivered">Delivered</option>
          </select>
        </div> */}

      </div>
    </div>
  );
};